import { render } from "./TotalShipment.vue?vue&type=template&id=5c3bf2cb&ts=true"
import script from "./TotalShipment.vue?vue&type=script&lang=ts"
export * from "./TotalShipment.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__